import Accordion from '@mui/material/Accordion';
import { styled } from 'styled-components';

export const StyledAccordion = styled(Accordion)`
  background-color: #f7f7f7;
  box-shadow: none;
  border: 1px solid #e0e0e0;
  margin-bottom: 10px;

  &.Mui-expanded {
    margin: 10px 0;
  }

  .MuiAccordionSummary-root {
    padding: 10px 20px;
  }

  .MuiAccordionDetails-root {
    padding: 20px;
    color: #666;
  }

  .MuiTypography-root {
    font-family: 'Roboto', sans-serif !important;
  }
`;

export const AccordionTitle = styled.div<{ isExpanded: boolean }>`
  font-family: 'Oswald', sans-serif !important;
  font-size: 24px !important;
  font-weight: bold;
  color: ${({ isExpanded }) => (isExpanded ? '#e5007d' : '#6D6B68')};
  text-transform: uppercase;

  @media (max-width: 500px) {
    font-size: 18px !important;
  }
`;

export const LIRPReport = styled.a`
  cursor: pointer;
  display: block;
  width: 100%;
  font-family: 'Roboto', sans-serif;
  line-height: 24px;
  color: #e5007d;
  margin-top: 30px;
  text-transform: uppercase;

  &:hover {
    color: #000;
  }
`;
